import { apiClient } from '@/services/ApiClient'

export default {
  deletePayment(id) {
    return apiClient
      .delete(`retailer-order-payments/${id}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
